"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_hooks_1 = require("@apollo/react-hooks");
// eslint-disable-next-line no-use-before-define
const react_1 = __importDefault(require("react"));
const apollo_boost_1 = require("apollo-boost");
const ActionButtons_1 = __importDefault(require("coact/pages/modules/pageAction/ActionButtons"));
const moment_1 = __importDefault(require("moment"));
const use_query_params_1 = require("use-query-params");
const queryParamsConfig_1 = __importDefault(require("./ui/queryParamsConfig"));
const YearMonthSelectorView_1 = __importDefault(require("./ui/YearMonthSelectorView"));
const DataTableView_1 = __importDefault(require("../ui/DataTableView"));
const PagedDataTableView_1 = __importDefault(require("./ui/PagedDataTableView"));
const DataTableField_1 = require("../stockRecordWorkflow/ui/DataTableField");
const typeDesc = {
    assert: '盤點',
    sale: '銷貨',
    purchase: '進貨',
};
const CLEAR_NEGATIVE_STOCK_QTY = apollo_boost_1.gql `
  mutation ($stockId: String!) {
    clearNegativeStockQty(id: $stockId)
  }
`;
const GET_STOCK_RECORDS = apollo_boost_1.gql `
  query getStockRecords($stockId: String!, $offset: Int, $limit: Int, $year: Int, $month: Int) {
    getStockInfo(stockId: $stockId, year: $year, month: $month) {
      _id
      stock {
        warehouse
        product {
          name
          key
        }
      }
      averageCost
      qty
    }
    getStockRecords(stockId: $stockId, offset: $offset, limit: $limit, year: $year, month: $month) {
      _id
      qty
      averageCost
      totalQty
      date
      type
      src {
        parentCollection
        parentId
        collection
        id
        sn
      }
      meta {
        tag
        desc
      }
    }
  }`;
function StockRecordsView(props) {
    const [query, setQuery] = use_query_params_1.useQueryParams(queryParamsConfig_1.default);
    const { year = new Date().getFullYear(), month = new Date().getMonth() + 1 } = query;
    const stockId = props.match.params.stockId;
    const [clearNegativeTotalQtyStock] = react_hooks_1.useMutation(CLEAR_NEGATIVE_STOCK_QTY, {
        refetchQueries: () => [{
                query: GET_STOCK_RECORDS,
                variables: {
                    stockId,
                    offset: 0,
                    limit: 0,
                    year,
                    month,
                },
            }],
        awaitRefetchQueries: true,
    });
    const { loading, error, data: rawData } = react_hooks_1.useQuery(GET_STOCK_RECORDS, {
        variables: {
            stockId,
            offset: 0,
            limit: 0,
            year,
            month,
        },
    });
    if (error)
        return react_1.default.createElement("div", null, JSON.stringify(error));
    let stockRecords = [];
    let stockInfo = null;
    if (!loading) {
        if (rawData === undefined)
            throw new Error('rawData is undefined');
        stockInfo = rawData.getStockInfo;
        stockRecords = rawData.getStockRecords;
    }
    else {
        return react_1.default.createElement("div", null, "\u8CC7\u6599\u8F09\u5165\u4E2D ...");
    }
    const stockHeader = {
        getUniqueId: (data) => {
            if (data._id === undefined)
                throw new Error('id is undefined.');
            return data._id;
        },
    };
    const stockRecordHeader = {
        getUniqueId: (data) => {
            if (data._id === undefined)
                throw new Error('_id is undefined.');
            return data._id;
        },
    };
    const stockFields = [
        {
            label: '商品代號',
            width: 200,
            textAlign: DataTableField_1.TextAlignment.Left,
            toFormat(data) {
                return data.stock.product.key;
            },
        },
        {
            label: '商品名稱',
            width: 500,
            textAlign: DataTableField_1.TextAlignment.Left,
            toFormat(data) {
                return data.stock.product.name;
            },
        },
        {
            label: '倉儲單位',
            width: 100,
            textAlign: DataTableField_1.TextAlignment.Left,
            toFormat(data) {
                if (data.stock.warehouse === undefined)
                    throw new Error('Warehouse is undefined.');
                return data.stock.warehouse;
            },
        },
        {
            label: '庫存數量',
            width: 100,
            textAlign: DataTableField_1.TextAlignment.Right,
            toFormat() {
                if (stockRecords.length === 0) {
                    return '0';
                }
                if (stockRecords[0].totalQty === null) {
                    return 'N/A';
                }
                return stockRecords[0].totalQty.toString();
            },
        },
    ];
    if (props.canDisplayCost) {
        stockFields.push({
            label: '平均成本',
            width: 100,
            textAlign: DataTableField_1.TextAlignment.Right,
            toFormat() {
                if (stockRecords.length === 0) {
                    return '0';
                }
                if (stockRecords[0].averageCost === null) {
                    return 'N/A';
                }
                return stockRecords[0].averageCost.toString();
            },
        });
    }
    const stockRecordFields = [
        {
            label: '日期',
            width: 100,
            textAlign: DataTableField_1.TextAlignment.Left,
            toFormat(item) {
                return moment_1.default(item.date).format('YYYY/MM/DD');
            },
        },
        {
            label: '類型',
            width: 80,
            textAlign: DataTableField_1.TextAlignment.Left,
            toFormat(item) {
                if (item.meta !== null
                    && item.meta.tag !== null) {
                    return item.meta.tag.join('.');
                }
                if (item.type != null) {
                    return typeDesc[item.type];
                }
                console.log('item.type is undefined.');
                return '(N/A)';
            },
        },
        {
            label: '數量變動',
            width: 80,
            textAlign: DataTableField_1.TextAlignment.Right,
            toFormat(item) {
                if (item.qty === undefined) {
                    return 'N/A';
                }
                return item.qty.toString();
            },
        },
        {
            label: '庫存數量',
            width: 80,
            textAlign: DataTableField_1.TextAlignment.Right,
            toFormat(item) {
                if (stockRecords[0].totalQty === null) {
                    return 'N/A';
                }
                return item.totalQty.toString();
            },
        },
    ];
    if (props.canDisplayCost) {
        stockRecordFields.push({
            label: '平均成本',
            width: 80,
            textAlign: DataTableField_1.TextAlignment.Right,
            toFormat(item) {
                if (item.averageCost == null) {
                    return 'N/A';
                }
                return item.averageCost.toString();
            },
        });
    }
    stockRecordFields.push({
        label: '備註',
        width: 250,
        textAlign: DataTableField_1.TextAlignment.Left,
        toFormat(item) {
            if (item.meta == null || item.meta.desc == null)
                return '';
            return item.meta.desc;
        },
    }, {
        label: '來源',
        width: 200,
        textAlign: DataTableField_1.TextAlignment.Left,
        toFormat(item) {
            if (item.src === undefined) {
                return 'N / A';
            }
            if (item.src.sn != null) {
                return item.src.sn;
            }
            return item.src.id;
        },
        toUrl(item) {
            if (item.src === undefined) {
                return 'N / A';
            }
            if (item.src.sn === item.src.id) {
                return null;
            }
            if (item.src.parentCollection == null) {
                return `/edit/${item.src.collection}/view/main/${item.src.id}`;
            }
            if (item.src.parentCollection === 'asserts') {
                return `/${props.assertViewPath}/${item.src.parentId}`;
            }
            return `/edit/${item.src.parentCollection}/view/main/${item.src.parentId}`;
        },
    });
    const stockActions = [
        {
            text: '回上頁',
            onClick: () => __awaiter(this, void 0, void 0, function* () {
                props.history.goBack();
            }),
            props: {
                variant: 'outlined',
            },
        },
    ];
    const listAllAction = {
        text: '顯示所有紀錄',
        onClick: () => __awaiter(this, void 0, void 0, function* () {
            setQuery({ year: undefined, month: undefined });
        }),
        props: {
            variant: 'outlined',
        },
    };
    const clearanceAction = {
        text: '註銷負庫存',
        onClick: () => __awaiter(this, void 0, void 0, function* () {
            // eslint-disable-next-line no-alert
            if (window.confirm('確定要註銷負庫存？')) {
                yield clearNegativeTotalQtyStock({ variables: { stockId } });
            }
        }),
        props: {
            variant: 'outlined',
        },
    };
    const yearMonthSelectorActions = [listAllAction];
    if (stockRecords.length > 0 && stockRecords[0].totalQty < 0) {
        yearMonthSelectorActions.push(clearanceAction);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ActionButtons_1.default, { actions: stockActions, classes: null }),
        react_1.default.createElement("span", { style: { marginLeft: '1em' } }, "\u4E0B\u9762\u662F\u5230"),
        react_1.default.createElement("span", { style: { marginRight: '20px' } },
            react_1.default.createElement(YearMonthSelectorView_1.default, { year: year, month: month, setYear: (y) => { setQuery({ year: y }); }, setMonth: (m) => { setQuery({ month: m }); } }),
            "\u5E95\u70BA\u6B62\u7684\u5EAB\u5B58\u7D00\u9304"),
        react_1.default.createElement(ActionButtons_1.default, { actions: yearMonthSelectorActions, classes: null }),
        react_1.default.createElement(DataTableView_1.default, { header: stockHeader, fields: stockFields, data: [stockInfo] }),
        react_1.default.createElement(PagedDataTableView_1.default, { pageNum: 1, pageLimit: 50, setPageNum: () => { }, setPageLimit: () => { }, defaultFilter: "", setFilter: () => { }, isLoading: false, header: stockRecordHeader, fields: stockRecordFields, data: stockRecords })));
}
exports.default = StockRecordsView;
